import React from 'react';
import PropTypes from 'prop-types';

import CommonSection from '../../redesign/component/commonSection';

const SecurityDeposit = ({ securityDepositAmt, securityDepositLabel }) => {
  const securityAmt = parseFloat(securityDepositAmt) > 0;
  if (!securityAmt) {
    return null;
  }

  return (
    <CommonSection
      leftValueText={securityDepositLabel || 'Refundable deposit'}
      rightValueText={`$${parseFloat(securityDepositAmt).toFixed(2)}`}
      id="SecurityDeposit Info"
    />
  );
};

SecurityDeposit.propTypes = {
  securityDepositAmt: PropTypes.any,
  securityDepositLabel: PropTypes.string,
};
export default SecurityDeposit;
